import { history } from 'duck/store'
import React from 'react'
import { TableColumn } from 'scenes/Dashboard/components-next/Table'
import { makeStyles } from 'tss-react/mui'

import SectionLoading from '../../../../components/SectionLoading'
import { getUserDetailsPath } from '../../UserManager.routes'
import { UserTableActions } from './components'
import { useUserListViewStore } from './UserListViewStore'
import { User } from '../../../../../../entities-next/user'
import { UserTable } from '../../components/UserTable'

export type UserListViewActionsProps = {
  className?: string
}

export function UserListViewContent({ className }: UserListViewActionsProps) {
  const {
    state: { status, data = [], currentPage, isPreviousData, limit },
    actions: { goToPage },
  } = useUserListViewStore()
  const { classes } = useStyles()
  const isLoading = status === 'loading' || isPreviousData

  return (
    <div className={className}>
      {isLoading && <SectionLoading className={classes.loading} />}
      <UserTable
        data={data}
        currentPage={currentPage}
        limit={limit}
        onChangePage={goToPage}
        extraColumns={actionsRow}
        onRowSelect={onRowSelect}
      />
    </div>
  )
}

function onRowSelect(user: User) {
  history.push(getUserDetailsPath(user.id))
}

const actionsRow: TableColumn<User>[] = [
  {
    Header: 'Actions',
    accessor: getUserActionsColumn,
    preventEvents: true,
    width: 50,
  },
]

function getUserActionsColumn(user: User) {
  return <UserTableActions user={user} />
}

const useStyles = makeStyles()({
  content: {
    position: 'relative',
  },
  loading: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255,255,255,0.5)',
  },
})
